// Vue-Lodash
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

export default {
    install(Vue, options) {
        // name is optional
        Vue.use(VueLodash, { name: 'mps' , lodash: lodash });
    }
}
